import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-organizational-values',
  templateUrl: './organizational-values.component.html',
  styleUrls: ['./organizational-values.component.css']
})
export class OrganizationalValuesComponent implements OnInit {

  constructor(private CommonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.CommonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/organizational-values/organizational-values.component.ts